module.exports = __webpack_public_path__ + "static/media/edit.bacf8734.svg";